// Generated by ReScript, PLEASE EDIT WITH CARE

import * as JsxRuntime from "react/jsx-runtime";
import * as Home$CardocFrontendPartners from "../pages/Home.mjs";

var renderer = {
  prepare: (function (_props) {
      
    }),
  render: (function (_props) {
      return JsxRuntime.jsx(Home$CardocFrontendPartners.make, {});
    })
};

export {
  renderer ,
}
/* react/jsx-runtime Not a pure module */
